import React from 'react';
import { Row } from '@xingternal/xing-grid';
import { Button } from '@xingternal/button';
import styles from './styles.css';

import { Version, VersionStatus } from '../../../../models/version';
import { AppRoutes } from '../../../../RoutesConfig';
import { ApiPathConfig } from '../../../../api/api-path-config';

export interface FooterButtonProps {
  readOnly: boolean;
  submitting: boolean;
  version: Version;
  locale: string;
  dirtyForm: boolean;
  onEditCancelled: () => void;
}

export const FooterButtons = ({
  readOnly,
  submitting,
  version,
  locale,
  dirtyForm,
  onEditCancelled,
}: FooterButtonProps): React.ReactElement => {
  return (
    <>
      <Row className={styles.actionButtonsContainer}>
        <Button
          id="previewBtn"
          className={styles.actionButton}
          size="large"
          variant="secondary"
          loading={submitting}
          target="_blank"
          type="button"
          onClick={(): void => {
            (!dirtyForm ||
              confirm(
                'Changes were made but not saved. Still show the the saved version?'
              )) &&
              window.open(
                AppRoutes.admin.previewPageShow(
                  version.id,
                  locale,
                  version.genericId
                ),
                '_blank'
              );
          }}
        >
          Preview
        </Button>
        <Button
          id="previewPdfBtn"
          className={styles.actionButton}
          size="large"
          variant="secondary"
          loading={submitting}
          target={'_blank'}
          data-cy="preview-pdf-btn"
          href={ApiPathConfig.adminPrintPreview(
            version.id,
            version.genericId,
            locale
          )}
        >
          Preview (PDF)
        </Button>
        {dirtyForm && (
          <Button
            id="cancelBtn"
            data-cy="cancel-btn"
            className={styles.actionButton}
            disabled={readOnly}
            loading={submitting}
            size="large"
            variant="secondary"
            type="button"
            onClick={onEditCancelled}
          >
            Cancel
          </Button>
        )}
        {version.status === VersionStatus.draft && dirtyForm && (
          <Button
            id="saveBtn"
            data-cy="submit"
            className={styles.actionButton}
            type="submit"
            disabled={readOnly}
            size="large"
            variant="secondary"
            loading={submitting}
          >
            Save
          </Button>
        )}
      </Row>
    </>
  );
};
